import { z } from 'zod'

export const createTransferSchema = z.object({
  amount: z.number().positive(),
  convertedAmount: z.number().positive().optional(),
  conversionRate: z.number().positive().optional(),
  description: z.string().max(500).optional(),
  date: z
    .string()
    .datetime({ offset: true })
    .optional()
    .default(() => new Date().toISOString()),
  fromAccountId: z.string().guid(),
  toAccountId: z.string().guid(),
})

export type CreateTransferDto = z.infer<typeof createTransferSchema>
